<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Management Audit Trail</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Merchants</h4>
          <p class="sub-header">
            View audit trail for merchants for your current participant
          </p>

          <div class="row">

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width:100%;">
                <thead>
                  <tr>
                    <th>Merchant</th>
                    <th>Name / Location</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchant of merchants">

                    <td>{{ merchant.merchantNumber }}</td>
                    <td>{{ merchant.nameLocation }}</td>
                    <td>
                      <button type="button" style="ViewButtonStyle" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="viewMerchant(merchant)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody *ngIf="merchants?.length == 0">
                  <tr>
                    <td colspan="3" class="no-data-available">No merchants available to display!</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
